import axios from 'axios';

const API_URL = process.env.VUE_APP_API_BASE_URL + 'codes/';

class VenueService {

  getRejectReasons() {
    var full_api_url = API_URL + 'reject_reasons';

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }

  getAreas() {
    let venue_id = 1; // Mayfair
    var full_api_url = API_URL + 'venue_areas/' + venue_id;

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }

  getTitles() {
    var full_api_url = API_URL + 'titles';
    console.log("GET TITLES ....");
    console.log(full_api_url);

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }

  getPhotoIDTypes() {
    var full_api_url = API_URL + 'documents/4';

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }
}



export default new VenueService();
